/**
 * © [2023] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */

import * as TYPES from './action-types';
import axios from 'axios';
import * as serviceEndPoint from '../../../../../../SharedModules/services/service';

export const setDeleteBatchLoading = (payload) => {
  return {
    type: TYPES.DELETE_BATCH_LOADING,
    payload,
  };
};

export const setReabteProgramData = (payload) => {
  return {
    type: TYPES.DELETE_BATCH_REBATE_PROGRAM_DATA,
    payload,
  };
};

export const setDeleteBatchFilter = (payload) => {
  return {
    type: TYPES.DELETE_BATCH_FILTER,
    payload,
  };
};

export const setUserDefault = (payload) => {
  return {
    type: TYPES.DELETE_BATCH_USERDEFAULT,
    payload,
  };
};

export const resetDeleteBatchStore = () => {
  return {
    type: TYPES.DELETE_BATCH_RESET_STORE,
  };
};

export const setDeleteBatchFilterValue = (key, value) => {
  return (dispatch, getState) => {
    const currentDeleteBatchFilter = {
      ...getState().sharedState.deleteBatch.deleteBatchFilter,
    };
    currentDeleteBatchFilter[key] = value;
    dispatch(setDeleteBatchFilter(currentDeleteBatchFilter));
  };
};

export const getUserDefaults = (values) => async (dispatch, getState) => {
  dispatch(setDeleteBatchLoading(true));
  try {
    const response = await axios.post(
      `${serviceEndPoint.GET_USER_DEFAULTS}?userId=${values}`
    );

    if (response.data && response.data.data) {
      dispatch(setUserDefault(response.data.data));
    } else {
      dispatch(setUserDefault(null));
    }
  } catch (e) {
    dispatch(setUserDefault(null));
  }
  dispatch(setDeleteBatchLoading(false));
};

export const getRebateProgramCode = (values) => async (dispatch) => {
  dispatch(setDeleteBatchLoading(true));
  try {
    const response = await axios.post(
      `${serviceEndPoint.GET_ALL_REBATE_PROGRAMS}`,
      { planType: values }
    );

    if (response.data && response.data.data && response.data.data.length > 0) {
      let newData = [];
      response.data.data.forEach((item) => {
        newData.push({
          label: `${item.rebateProgramCd} | ${item.shortDescr}`,
          value: item.rebateProgramCd,
          ...item,
        });
      });
      dispatch(setReabteProgramData(newData));
    } else {
      dispatch(setReabteProgramData([]));
    }
  } catch (e) {
    dispatch(setReabteProgramData([]));
  }
  dispatch(setDeleteBatchLoading(false));
};

export const getBatchDetails = (
  values,
  successFunc = () => {},
  errorFuc = () => {}
) => {
  return async (dispatch) => {
    dispatch(setDeleteBatchLoading(true));
    try {
      const response = await axios.post(
        serviceEndPoint.DELETE_BATCH_TOTAL,
        values
      );

      successFunc(response.data || null);
    } catch (e) {
      errorFuc(e?.response?.data || null);
    }
    dispatch(setDeleteBatchLoading(false));
  };
};

export const setErrorMessages = (payload) => {
  return {
    type: TYPES.SET_ERROR_MESSAGE,
    payload,
  };
};
